import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { authClient } from '@/lib/auth'
import { useTopNav } from '@/context/top-nav-provider'
import { Main } from '@/components/layout/main'
import { ShiftTaskReportView } from '@/features/reports/shift-task-report'

function ShiftTaskReportPage() {
  const { data: activeOrganization, isPending } = authClient.useActiveOrganization()
  const { setLinks, setFixed } = useTopNav()

  useEffect(() => {
    setLinks([
      { title: 'Overview', href: '/' },
      { title: 'Reports', href: '/reports' },
      { title: 'Shift Tasks', href: '/reports/shift-tasks', isActive: true },
    ])
    setFixed(true)
    return () => { setLinks([]) }
  }, [setLinks, setFixed])

  if (isPending || !activeOrganization) return null

  return (
    <Main className='flex flex-1 flex-col gap-6'>
      <ShiftTaskReportView organizationId={activeOrganization.id} />
    </Main>
  )
}

export const Route = createFileRoute('/_authenticated/_organization/reports/shift-tasks')({
  beforeLoad: async () => requireRoles(['owner', 'admin', 'team_leader']),
  component: ShiftTaskReportPage,
})
